import { Controller } from '@hotwired/stimulus';

export default class InviteInvestorController extends Controller {
  static targets = ['body'];

  static values = {
    successMessage: String,
    errorMessage: String,
    reloadDelay: { type: Number, default: 300 },
  };

  onSuccess() {
    bootstrap.Modal.getInstance(this.element)?.hide();
    toastr.success(this.successMessageValue);
    window.setTimeout(() => window.location.reload(), this.reloadDelayValue);
  }

  onError(event) {
    const [, , xhr] = event.detail;
    this.bodyTarget.innerHTML = xhr.responseText;
    toastr.error(this.errorMessageValue);
  }
}
